<template>
    <div class="famous-pedia-read-web-page dsp-flex">
        <!-- 1. 顶部操作栏 -->
        <web-famous-pedia-top-bar></web-famous-pedia-top-bar>

        <!-- 2. 左边部分 -->
        <famous-pedia-left-web></famous-pedia-left-web>

        <div class="famous-pedia-read-web-right">
            <!-- 3. 迷你命盘部分 -->
            <div class="famous-form-rw-fatefortune">
                <mini-fate-fortune-panel
                    v-if="showPediaCommentFateFortune"
                    v-bind:fromPage="pageName"
                    v-bind:fortuneItemFunc="changeFateSideListData"
                    v-bind:fateSideCloseFunc="changeFateSideListData">
                </mini-fate-fortune-panel>
            </div>
            <!-- 4. 主要内容部分 -->
            <famous-form-read-web
                v-if="!showPediaCommentAllList">
            </famous-form-read-web>
            <!-- 5. 二级评论页面 -->
            <famous-comment-all-list
                v-if="showPediaCommentAllList">
            </famous-comment-all-list>
        </div>

        <!-- 6. 底部输入框 -->
        <web-famous-pedia-bottom-bar
            v-if="curPediaEditType == 'read'">
        </web-famous-pedia-bottom-bar>

        <!-- 7. 二级页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import WebFamousPediaTopBar from '../../layouts/web/WebFamousPediaTopBar.vue'
import WebFamousPediaBottomBar from '../../layouts/web/WebFamousPediaBottomBar.vue'
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import CommentContentRead from '../../layouts/comment/CommentContentRead.vue'
import FamousPediaLeftWeb from '../../layouts/famouspediaweb/FamousPediaLeftWeb.vue'
import FamousFormReadWeb from '../../layouts/famouspediaweb/FamousFormReadWeb.vue'
import FamousCommentAllList from '../../layouts/famouscomment/FamousCommentAllList.vue'
import { DOM, FAMOUS_DOM } from '../../modules/dom';
import { SHARE } from '../../modules/share'
import { UA } from '../../modules/utils'
import { CONFIG } from '../../modules/config'
export default {
    name: 'FamousPediaReadWeb',
    components: { WebFamousPediaTopBar, WebFamousPediaBottomBar, MiniFateFortunePanel, CommentContentRead, FamousPediaLeftWeb, FamousFormReadWeb, FamousCommentAllList },
    computed: {
        curPediaEditType() {
            return this.$store.state.famouspedia.curPediaEditType;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        },
        showPediaCommentAllList() {
            return this.$store.state.famouspediacomment.showPediaCommentAllList
        },
        showPediaCommentFateFortune() {
            return this.$store.state.famouspediacomment.showPediaCommentFateFortune
        }
    },
    data() {
        return {
            pageName: 'FamousPediaReadWeb',
        }
    },
    updated() {
        SHARE.initConfigShare();
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
        }, 20);
    },
    created() {
        this.$bus.on('triggerTitleLinkItem', this.triggerTitleItemFunc);
    },
    destroyed() {
        this.$bus.off('triggerTitleLinkItem', this.triggerTitleItemFunc);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = (innerHeight - 42) + 'px';
        },
        initData() {
            if(this.curPediaBaziInfo && this.curPediaBaziInfo.id) {
                return;
            }
            var curParams = this.$router.history.current.params,
                curId = curParams ? curParams.id : 0;
            if(!curId) {
                this.$router.replace('/webhome');
                return;
            }

            // 处理不同平台的跳转
            if(UA.isPcWeChat() || UA.isWeChat()) {
                window.location.href = CONFIG.wechat_url + '/share/famouspediaread/' + curId + '/famouspedia';
            }else if(UA.isQQ()) {
                window.location.href = CONFIG.qq_url + '?path=share-famouspediaread-' + curId + '-famouspedia';
            }
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: curId,
                baikeType: 'hot',
                baikeStatus: 4
            });
        },
        // 迷你命盘运盘的数据与大运流年数据的联动
        changeFateSideListData(data, fateSideListData) {
            FAMOUS_DOM.bindFamousFormScrollEvent(false);
            var commentAllKey = this.$store.state.famouspediacomment.commentAllKey,
                commentAllYear = this.$store.state.famouspediacomment.commentAllYear,
                curPediaDayunLiunianList = this.$store.state.famouspedia.curPediaDayunLiunianList,
                showPediaCommentAllList = this.$store.state.famouspediacomment.showPediaCommentAllList,
                commentTotalReplyData = this.$store.state.famouspediacomment.commentTotalReplyData;
            if(fateSideListData.length == 0) {
                this.updateDom('');
            }else {
                if(data.type == 'dayun') {
                    this.updateDom(data.type + data.year)
                    // 更新流年的评论状态
                    this.$store.dispatch('minifatefortune/updateFamousMiniLiunianListCommentStatus', {
                        pediaList: curPediaDayunLiunianList,
                        commentData: commentTotalReplyData
                    });
                }else if(data.type == 'liunian') {
                    this.updateDom(data.type + data.year)
                    // 更新当前全部评论列表的数据
                    if(fateSideListData.length == 2) {
                        var dayunIndex = fateSideListData[0].index,
                            liunianIndex = fateSideListData[1].index, liunianYear = fateSideListData[1].year,
                            dayunData = curPediaDayunLiunianList[dayunIndex],
                            liunianData = dayunData['liunian'][liunianIndex],
                            curKey = 'big_' + dayunData.key + '_' + liunianData.key;
                        if(liunianData.content != '' && showPediaCommentAllList) {
                            this.updateCommentAllList(curKey);
                        }
                    }
                }
            }
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 1000);
        },
        triggerTitleItemFunc(itemId) {
            if(itemId == '') {
                window.scrollTo(0, 0)
                return;
            }
            console.error('triggerTitleItemFunc------', itemId)
            var me = this;
            setTimeout(() => {
                me.updateDom(itemId);
                FAMOUS_DOM.bindFamousFormScrollEvent(false);
            }, 20);
            setTimeout(() => {
                me.$store.dispatch('minifatefortune/triggerFortuneItemFunction', itemId);
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 100);
        },
        updateCommentAllList(key) {
            var me = this,
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', { 
                key: key,
                cb: function() {
                    setTimeout(() => {
                        // FAMOUS_DOM.updateFamousFormStyle();
                        FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        window.scrollTo(0, 0);
                    }, 20);
                }
            });
        },
        updateDom(curName) {
            var curTab = this.$store.state.famouspedia.curPediaContentTab;
            if(curTab == 1) {
                FAMOUS_DOM.updateFamousReadStoryScrollTop(curName);
            }else if(curTab == 2) {
                FAMOUS_DOM.updateFamousReadCommentScrollTop(curName);
            }
        },
    }
}
</script>